
import { validationTypes } from "../../../../../components/FinalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../components/FinalForms/libs/data/formFieldType";

export const configureSkillCategoryFormData = {
    name: "Skill Category Form ",
    initialState: {
        skillCategoriesId:"",
    
    },
    section: [
        {
            title: "Skill Category Section",
            row: {},
            style: {
                sectionStyle: "row",
            },
            fields: [
                {
                    id: "skillCategoriesId",
                    label: "Skill Category",
                    Field_Name: "Skill Category",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "skillCategoriesId",
                    fieldSetting: {
                        placeholder: "Select Skill Category",
                        options: [],
                        isMultiSelect: false,
              
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-12 mb-2",
                    },
                },
            ]
        },
    ]
};


export const configureMainSkillFormData = {
    name: "Main Skill Form ",
    initialState: {
        mainSkillId:"",
    
    },
    section: [
        {
            title: "Main Skill Section",
            row: {},
            style: {
                sectionStyle: "row",
            },
            fields: [
                {
                    id: "mainSkillId",
                    label: "Main Skill",
                    Field_Name: "Main Skill",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "mainSkillId",
                    fieldSetting: {
                        placeholder: "Select Main Skill",
                        options: [],
                        isMultiSelect: true,
              
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-12 mb-2",
                    },
                },
            ]
        },
    ]
};


export const configureSubSkillFormData = {
    name: "Sub Skill Form ",
    initialState: {
        subSkillId:"",
        isSubSkillRequired:false,
    },
    section: [
        {
            title: "Sub Skill Section",
            row: {},
            style: {
                sectionStyle: "row",
            },
            fields: [
                {
                    id: "subSkillId",
                    label: "Sub Skill",
                    Field_Name: "Sub Skill",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "subSkillId",
                    fieldSetting: {
                        placeholder: "Select Sub Skill",
                        options: [],
                        isMultiSelect: true,
              
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-12 mb-2",
                    },
                },
                {
                    id: "isSubSkillRequired",
                    label: "Is Sub Skill Required",
                    Field_Name: "isSubSkillRequired",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "isSubSkillRequired",
                    style: {
                        containerCss: "col-md-6 mb-3 is-enable",
                    },
                },
            ]
        },
    ]
};